import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useClassName } from '../../hooks';
import { Icon } from '../Icon/Icon';
import { useIconSize } from '../Avatar/hooks/useIconSize';
import { useSrcWithFallback } from './hooks';
import '../Avatar/Avatar.scss';
/**
 * Avatar Component in that accepts multiple URLS. It will try to load the first URL in the array and if it fails, it will try the next one.
 */
export const AvatarMultiple = ({ srcs, fallbackIcon, variant, size = 'medium', loading }) => {
    const [hasError, setHasError] = useState(false);
    const { loading: imageIsLoading, srcWithFallback } = useSrcWithFallback({ srcs, setHasError });
    const iconSize = useIconSize({ size });
    const className = useClassName({ name: 'avatar', prefixed: true }, variant === 'circle' && 'circle', variant === 'square' && 'square', (loading || imageIsLoading) && 'loading', hasError && 'has-error', size);
    if (loading || imageIsLoading)
        return _jsx("div", { className: className });
    if (hasError)
        return (_jsx("div", { className: className, children: _jsx(Icon, { color: 'neutral-300', name: fallbackIcon, size: iconSize }) }));
    return _jsx("img", { "data-testid": 'avatar', className: className, src: srcWithFallback });
};
